import PropTypes from 'prop-types';

import Category from './Category';

const Menu = PropTypes.shape({
  option_groups: PropTypes.arrayOf(Category),
});

export default Menu;
